import React, { useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { setCurrentStep, setServiceToTransfer, setCurrentPopUp, submitServiceValidation } from '../OwnershipTransferSellerSlice';
import { OwnershipTransferPrivateSellerStep, ServiceType, ProductType, PopupMessageContent } from '../Constant/Constant';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'
import EasyTransferMessage from '../Shared/EasyTransferMessage';
import ImportantToKnowItem from '../Shared/ImportantToKnowItem';
import SelectList from 'app/Components/Shared/SelectList/SelectList';

const SelectStationaryLineType = (props) => {
    const [error, setError] = useState(false);
    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            dwhGeneralReport({
                data: { ...props.data, userDetails: props.userDetails },
                actionType: DwhActionType.SelectLineAddressPage,
                messageText: DWHMessageText.SelectLineAddressPageDisplayed,
                status: DWHStatus.Ongoing,
            });
        }
    }, []);

    function submitServiceValidation() {
        if (props.data.serviceToTransfer == null) {
            setError(true);
        }
        else if (!props.data.serviceToTransfer.assetExternalId?.trim() || (props.data.serviceToTransfer.accountType != "I" && props.data.serviceToTransfer.accountType != "S")) {
            props.setCurrentPopUp(PopupMessageContent.TransferGeneralError)
        }
        else {
            //validate selection
            gaButtonClick();
            let product = {
                AssetExternalId: props.data.serviceToTransfer.assetExternalId,
                SubscriberNo: props.data.serviceToTransfer.subscriberNumber
            }

            props.submitServiceValidation(product)

        }
    }

    function saveSelectedService(selectedItem) {
        props.setServiceToTransfer({
            item: selectedItem,
            productType: selectedItem.productType,
        })
    }

    function getGeneralSelectBoxOptions() {
        const generalSelectBoxOptions = [];
        function addItem(item, type) {
            const newItem = { ...item, productType: type };
            generalSelectBoxOptions.push({ key: newItem.packageName, keyText: newItem.customerAddress, value: newItem });
        };

        props.productsAndServices?.Bundle?.map(bundle => addItem(bundle, ProductType.Bundle));
        props.productsAndServices?.TV?.map(tv => addItem(tv, ProductType.TV));
        props.productsAndServices?.Mapa?.map(mapa => addItem(mapa, ProductType.Mapa))
        props.productsAndServices?.MapaKosher?.map(MapaKosher => addItem(MapaKosher, ProductType.Mapa))
        props.productsAndServices?.InternetIsp?.map(int => addItem(int, ProductType.Internet))
        props.productsAndServices?.Internet?.map(int => addItem(int, ProductType.Internet))
        props.productsAndServices?.InternetInfra?.map(int => addItem(int, ProductType.Internet))
        props.productsAndServices?.InternetInfraKosher?.map(int => addItem(int, ProductType.Internet))

        return generalSelectBoxOptions;
    }

    function gaButtonClick() {

        dwhGeneralReport({
            data: { ...props.data, userDetails: props.userDetails },
            actionType: DwhActionType.SelectLineAddressPage,
            messageText: DWHMessageText.SelectLineAddressPageButtonClicked,
            status: DWHStatus.Ongoing,
        });
    }

    return (
        <div className='ownership-transfer-select-stationary-line ownership-transfer-step'>

            <div className='l-title center'> לאיזה שירות תרצו להעביר בעלות?</div>
            <div className='stepContainer'>

                <SelectList options={getGeneralSelectBoxOptions()}
                    onClick={(e) => saveSelectedService(e)} />

                <EasyTransferMessage />
            </div>
            {props.iContent.importantListServices?.expandedValue?.length > 0
                && props.iContent.importantListServices?.expandedValue[0].itemList?.expandedValue.length > 0 &&

                <div className='important-to-know'>
                    <div className='m-title semi'>{props.iContent.importantListServices?.expandedValue[0].title.value}</div>
                    {props.iContent.importantListServices?.expandedValue[0].itemList?.expandedValue?.map((item, index) => {
                        return <ImportantToKnowItem item={item} index={index} />
                    }
                    )}
                </div>
            }
            <div className='continue-button'>
                {error && <div className='error center'>כדי להמשיך יש לבחור שירות</div>}
                <BtnSubmit onclick={submitServiceValidation} text={'המשך'} />
            </div>

        </div >
    );
};

const mapStateToProps = (state) => ({
    data: state.OwnershipTransferPrivateSeller,
    productsAndServices: state.selfcarePage.productsBySubscriber,
    userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
    setCurrentStep,
    setServiceToTransfer,
    setCurrentPopUp,
    submitServiceValidation
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectStationaryLineType);
